var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.75 0H468v600H210.75Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 119h349.25v362H400Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.35278 0 0 .35278 -64.412 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M467.754 557.05c0 23.696-19.145 42.84-42.844 42.84h-85.683c-70.954 0-128.524-57.566-128.524-128.523V128.633c0-70.957 57.57-128.524 128.524-128.524h85.683c23.7 0 42.844 19.145 42.844 42.844 0 23.695-19.145 42.84-42.844 42.84h-85.683c-23.696 0-42.84 19.144-42.84 42.84v342.734c0 23.695 19.144 42.84 42.84 42.84h85.683c23.7 0 42.844 19.145 42.844 42.844m0 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(.35278 0 0 .35278 -64.412 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m597.746 130.504 138.668 138.668c8.129 8.129 12.758 19.308 12.758 30.828s-4.629 22.7-12.758 30.828L597.746 469.492c-7.226 7.227-16.941 11.18-27.101 11.18-21.118 0-38.278-17.164-38.278-38.281v-70.125h-95.984c-19.985 0-36.133-16.149-36.133-36.133v-72.266c0-19.992 16.148-36.137 36.133-36.137h95.984v-70.125c0-21.113 17.16-38.277 38.278-38.277 10.16 0 19.875 4.067 27.101 11.176m0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogout);
export default __webpack_public_path__ + "static/media/new_logout.0eb8ffe688f0492afbfa599db764cacf.svg";
export { ForwardRef as ReactComponent };